export const RETURNED_FROM_COINBASE_PARAM = "returned_from_coinbase";
